import React, { Component } from "react";
import { connect } from "react-redux";

import Api from "../api";
import _ from "lodash";
import { Loader } from "react-loaders";
import { Alert } from "react-bootstrap";
import { ResettingPassword } from "../components";
import Translator from "../translations";
import Cookies from "universal-cookie";
import { Modal } from "react-bootstrap";

const cookies = new Cookies();
class Home extends Component {
  state = {
    locationParams: null,
    message: null,
    messageType: "info",

    modalTitle: "Verification de votre licence",
    modalMessages: [],
    isModalVisible: false
  };

  componentDidMount() {
    const { history } = this.props;
    let params = this.getParameters();
    this.setState({ locationParams: params });

    let { qrcode } = params;
    const smartPress = cookies.get("smartPress");

    if (qrcode || this.props.match.params.qrcode !== undefined) {
      // if (this.props.match.params.qrcode !== undefined) {
      //   qrcode = this.props.match.params.qrcode;
      // }

      if (this.props.match.params.qrcode !== undefined) {

        Api.checkQrCode(
          process.env.REACT_APP_KIOSK_ID,
          this.props.match.params.qrcode
        )
          .then(resp => {
            const expires = new Date();
            expires.setDate(
              expires.getDate() + (resp.countDayBeforeExpires || 7)
            );
            cookies.set("smartPress", this.props.match.params.qrcode, {
              expires
            });
            history.push("/publications");
          })
          .catch(error => {
            this.setState({
              isModalVisible: true,
              modalTitle: "Qr Code invalide",
              modalMessages: [
                "Vous devez scanner le QrCode pour accèder à la presse.",
                error && error.message ? "Details: " + error.message : "",
                "",
                "Si le problème persiste après avoir scanner le QrCode veuillez nous contacter par email à l'adresse contact@propress.fr ou en cliquant  <a href='/#/contact' style='color:#337ab7'>ici</a>",
                "",
                "",
                "Merci et à très bientôt"
              ]
            });
          });
      } else {
        const expires = new Date();
        expires.setDate(expires.getDate() + 7);
        cookies.set("smartPress", qrcode, {
          expires
        });
        history.push("/publications");
      }
    } else {
      if (smartPress === undefined) {
        this.setState({
          isModalVisible: true,
          modalTitle: "Authentification",
          modalMessages: [
            "Vous devez scanner le QrCode pour accèder à la presse",
            "",
            "Si le problème persiste après avoir scanner le QrCode veuillez nous contacter par email à l'adresse contact@propress.fr ou en cliquant  <a href='/#/contact' style='color:#337ab7'>ici</a>",
            "",
            "",
            "Merci et à très bientôt"
          ]
        });
      } else {
        history.push("/publications");
      }
    }
  }

  getParameters() {
    const { location } = this.props;
    let params = {},
      requestParams = {};
    const { search, hash } = location;
    requestParams = _.merge(_.split(search, "#"), _.split(search, "?"));
    requestParams = _.merge(requestParams, _.split(hash, "?"));
    requestParams = _.merge(requestParams, _.split(hash, "?"));
    // requestParams = _.merge(requestParams, _.split(hash,'#'));

    _.forEach(requestParams, (item, i) => {
      let splited = _.split(item, "=");
      if (splited.length === 2) {
        params[splited[0]] = splited[1];
      }
    });

    return params;
  }

  getParameter(key, defaultValue = null) {
    let locationParams = this.state.locationParams;

    if (this.state.locationParams === null) {
      locationParams = this.getParameters();
    }
    return locationParams[key] || defaultValue;
  }

  renderRegistrationCompletteLoader() {
    const confirmationToken = this.getParameter("confirmation_token");
    if (!confirmationToken) return null;

    return (
      <div className="margin-top-40 margin-bottom-40">
        <h1>{Translator.t("processing")}</h1>
        <Loader
          type="ball-beat"
          size={"lg"}
          active
          styles={{ width: 40, height: 40 }}
        />
      </div>
    );
  }

  renderResettingPassword() {
    const recover_token = this.getParameter("recover_token");
    if (!recover_token) return null;

    return (
      <div className="margin-top-40 margin-bottom-40">
        <ResettingPassword
          token={recover_token}
          onResetting={() => {
            setTimeout(() => {
              this.props.history && this.props.history.push("/login");
            }, 2000);
          }}
        />
      </div>
    );
  }

  render() {
    const {
      message,
      messageType,
      modalTitle,
      modalMessages,
      isModalVisible
    } = this.state;
    if (isModalVisible) {
      return (
        <Modal
          bsSize="large"
          show={true}
          keyboard={false}
          aria-labelledby="contained-modal-title-lg"
        >
          <Modal.Header>
            <Modal.Title
              componentClass="h3"
              id="contained-modal-title-lg"
              className="text-center"
            >
              {modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {_.isEmpty(modalMessages) && (
              <div className=" margin-top-20 margin-bottom-20">
                <Loader
                  type="ball-beat"
                  size="lg"
                  color={"#4476AC"}
                  styles={{ width: 45, height: 45 }}
                />
              </div>
            )}

            {!!modalMessages &&
              _.map(modalMessages, (msg, i) => (
                <p key={i} dangerouslySetInnerHTML={{ __html: msg }} />
              ))}
          </Modal.Body>
        </Modal>
      );
    }
    return (
      <div className="container text-center margin-top-40 margin-bottom-40">
        <div className="margin-top-40 margin-bottom-40">
          {message && (
            <Alert bsStyle={messageType || "warning"} className="flat">
              {message}
            </Alert>
          )}
          {this.renderRegistrationCompletteLoader()}
          {this.renderResettingPassword()}
        </div>
      </div>
    );
  }
}

function bindAction(dispatch) {
  return {};
}

const mapStateToProps = state => ({
  apiKey: state.security.user ? state.security.user.apiKey : null,
  user: state.security.user || null
  // isAuth: !!state.security.user,
});

export default connect(
  mapStateToProps,
  bindAction
)(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js